import { getDisplayName } from './getDisplayName';
/**
 * Функция для создания displayName у HOC
 *
 * @export
 * @param {React.ComponentType} Component
 * @param {string} hocName
 * @returns {string}
 */

export function wrapDisplayName(Component, hocName) {
  return "".concat(hocName, "(").concat(getDisplayName(Component), ")");
}